import React, { useContext, useMemo, useState } from 'react';
import { IntegrationContext } from '../../../../context/IntegrationContext';
import { IntegrationSettingsUtil } from '../../../../types/integration_settings';
import { IntegrationSettings } from '../../../../types/integration_settings/integrationSettings';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { toFilterString } from '../../../../util/string.util';
import { Banner, BannerType } from '../../../components/Banner';
import { AddButton } from '../../../components/Button';
import { Card } from '../../../components/Card';
import { NoItemsFound } from '../../../components/NoItems';
import { Searchbar } from '../../../components/TextInput';
import { IconType } from '../../../icons/Icon';
import IntegrationModal from './Modals/IntegrationModal';

interface ModalProps {
  open: boolean;
  integration: IntegrationSettings | undefined;
}

export default function IntegrationSettingsScreen() {
  const { integrationSettings } = useContext(IntegrationContext);

  const allItems = useMemo(() => [...integrationSettings.values()], [integrationSettings]);

  const [query, setQuery] = useState('');
  const [modalProps, setModalProps] = useState<ModalProps>({ open: false, integration: undefined });

  const filteredItems = () => {
    return [
      ...allItems.filter(item => {
        if (toFilterString(item.name).includes(query)) return true;
        if (toFilterString(item.environment).includes(query)) return true;
        return false;
      }),
    ];
  };

  const items = filteredItems();

  return (
    <>
      {modalProps.open && (
        <IntegrationModal
          open={modalProps.open}
          setOpen={open => setModalProps({ ...modalProps, open })}
          integration={modalProps.integration}
        />
      )}

      <div className='content-x content-y-screen flex h-full flex-grow flex-col gap-8'>
        <div className='grid gap-2'>
          <p className='page-title'>{t(TranslationKey.integrationSettingsScreenTitle).singular.upper}</p>
          <p className='subtitle'>{t(TranslationKey.integrationSettingsScreenSubtitle).singular.upper}</p>
        </div>
        <Banner type={BannerType.warning} title={t(TranslationKey.integrationSettingsBannerTitle).singular.upper}>
          <p className='subtitle'>{t(TranslationKey.integrationSettingsBannerContent).singular.upper}</p>
        </Banner>
        <div className='flex flex-grow flex-col gap-4'>
          <div className='flex justify-between'>
            <Searchbar value={query} onChange={setQuery} />
            <AddButton onClick={() => setModalProps({ open: true, integration: undefined })} />
          </div>

          {items.length ? (
            <div className='grid grid-flow-col gap-4'>
              {items.map(item => (
                <Card key={item.id} size={'lg'} onClick={() => setModalProps({ open: true, integration: item })}>
                  <div className='grid place-items-center gap-2 text-center'>
                    <div className='grid place-items-center gap-1'>
                      <img src={IntegrationSettingsUtil.integrationSettingsImage(item.type)} className='w-64' />
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          ) : (
            <div className='flex flex-grow items-center justify-center'>
              <NoItemsFound
                icon={IconType.settings4}
                title={!allItems.length ? t(TranslationKey.noIntegrationsYetTitle).singular.upper : undefined}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
